import React, { useContext, useState } from 'react';
import { Theme, ThemeContext } from '@ordermentum/ui-shared/utilities/theme';
import {
  ColorCodes,
  colorsForTheme,
} from '@ordermentum/ui-shared/foundations/color';
import { ThemeProvider } from 'emotion-theming';
import useInterval from '@ordermentum/ui-shared/hooks/useInterval';
import Button from '@ordermentum/ui-shared/components/Button/Button';
import {
  MFAResendContainer,
  MFAResendText,
  MFAResentTextBold,
} from './MFAForm.styles';

type themeStyles = {
  headerColor: ColorCodes;
  descriptionColor: ColorCodes;
};

const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  return {
    headerColor: colors.SPACE,
    descriptionColor: colors.STORM,
  };
};

export const RESEND_COUNTDOWN = 60;

type props = {
  onCodeResend: () => void;
};

export const MFAResend = ({ onCodeResend }: props) => {
  const [isCountingDown, setIsCountingDown] = useState<boolean>(true);
  const [counter, setCounter] = useState<number>(RESEND_COUNTDOWN);
  const themeContext = useContext(ThemeContext);
  const theme = getTheme(themeContext);

  const onResend = () => {
    onCodeResend();
    setIsCountingDown(true);
    setCounter(RESEND_COUNTDOWN);
  };

  const intervalRef = useInterval(
    () => {
      if (counter > 0) {
        setCounter(prevCounter => prevCounter - 1);
      } else {
        setIsCountingDown(false);
        window.clearInterval(intervalRef.current);
      }
    },
    isCountingDown ? 1000 : null
  );

  return (
    <ThemeProvider theme={theme}>
      <MFAResendContainer>
        {!isCountingDown ? (
          <MFAResendText>
            Didn&apos;t receive the code?
            <Button variant="tertiary" onClick={onResend}>
              Resend
            </Button>
          </MFAResendText>
        ) : (
          <MFAResendText>
            Resend code in <MFAResentTextBold>{counter}s</MFAResentTextBold>
          </MFAResendText>
        )}
      </MFAResendContainer>
    </ThemeProvider>
  );
};

export default MFAResend;
